export enum QuestionnaireStepsEnum {
    rates = 5,
    availability = 6,
    bankDetails = 7,
    cancellationPolicy = 8,
    badge = 9,
    carAndInsurance = 10
}